'use strict';
angular.module('schoolLinqApp').directive('rcRadio', function () {
	return {
		require: ['ngModel'],
		scope: {
			labelName: '@',
			options: '=',
			ngModel: '=',
		},
		replace: true,
		restrict: 'E',
		template: require('@ajs/templates/reports/rcRadio.html'),
		controller: [
			'$scope',
			function ($scope) {
				$scope.isOpen = false;
				$scope.click = function (option) {
					$scope.ngModel = option;
				};
			},
		],
	};
});
